import React from "react";
// import LoaderImg from '../../assets/loader.gif'
const Loader = ({showHide}) =>{
    return(
        showHide && <div className="loader">
            {/* <img src={LoaderImg}/> */}
            Loading...</div>
    )
}
export default Loader;